<fin-booking-widget-selector
  class="flex flex--half overflow-hidden"
  [label]="'bookingSearch.from.title' | finLocalization"
  [disabled]="disabled"
  (click)="openModal('origin')"
  [attr.data-test-location-selector]="'origin'"
>
  <ng-container *ngTemplateOutlet="locationInfo; context: { location: (locations$ | async)?.origin }"></ng-container>
</fin-booking-widget-selector>

<ng-container *ngIf="showSeparator">
  <fcom-button
    class="flex flex--center flex--self-center absolute location-switch"
    [icon]="{ category: 'svg-library', name: 'switch-flights', position: IconPosition.LEFT }"
    [theme]="ButtonTheme.SECONDARY"
    [size]="ButtonSize.S_SMALL"
    (click)="locationsSwitched.emit()"
    data-test-switch-locations
  ></fcom-button>
</ng-container>

<fin-booking-widget-selector
  class="flex flex--half overflow-hidden"
  [label]="'bookingSearch.to.title' | finLocalization"
  [disabled]="disabled"
  (click)="openModal('destination')"
  [attr.data-test-location-selector]="'destination'"
  [separatorPadding]="'laptopUp'"
>
  <ng-container
    *ngTemplateOutlet="locationInfo; context: { location: (locations$ | async)?.destination }"
  ></ng-container>
</fin-booking-widget-selector>

<fcom-modal
  *ngIf="locationType$ | async as locationType"
  [(open)]="modalOpen"
  [title]="'bookingSearch.' + (locationType === 'origin' ? 'from' : 'to') + '.title' | finLocalization"
  [fitToContent]="false"
  [focusTarget]="searchInput.inputElement"
  (close)="closeModal()"
  data-test-location-modal
>
  <div>
    <div class="flex flex--middle pr-large-x pr-small-y" data-test-location-search-form>
      <fcom-text-input
        class="flex-1"
        [id]="'locationSearch-input'"
        [parentForm]="locationSearchForm"
        [translationPrefix]="'bookingWidget.destinationSearch.' + (locationType === 'origin' ? 'from' : 'to')"
        [controlName]="'locationSearch'"
        [required]="false"
        [placeHolder]="'bookingSearch.' + (locationType === 'origin' ? 'from' : 'to') + '.inputPlaceholder'"
        [displayMargin]="false"
        [ariaOptions]="{ describedby: 'location-search-info' }"
        (keydown.enter)="moveFocusToResults($event)"
        #searchInput
        data-test-search-input
      ></fcom-text-input>

      <div *ngIf="showLocateMe && locationType === 'origin'" class="flex flex--end mr-xxsmall-l">
        <fcom-button
          *ngIf="locationType === 'origin'"
          (click)="getUserLocation()"
          [text]="'bookingSearch.locateMe' | finLocalization"
          [icon]="{ category: 'svg-library', name: 'gps-location', position: IconPosition.RIGHT }"
          [mode]="ButtonMode.INLINE"
          [size]="ButtonSize.R_SMALL"
          [theme]="ButtonTheme.SECONDARY_WHITE"
          [loading]="isGeoLocating$ | async"
          [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          data-test-locateMe
        >
        </fcom-button>
      </div>

      <p id="location-search-info" class="is-vishidden">
        {{ 'bookingSearch.a11y.locationSearchDescription.' + locationType | finLocalization }}
      </p>
    </div>

    <fin-previous-searches
      *ngIf="(enablePersonalization$ | async) === true && modalOpen && (queryString$ | async)?.length === 0"
      (closeLocationModal)="closeModal()"
    ></fin-previous-searches>

    <div class="grey-50-bg rounded-small pr-large-x ps-medium-y">
      <h3
        class="font-body-1 nordic-blue-900-text"
        [attr.id]="locationType + '-list-title'"
        [tabIndex]="-1"
        #locationListHeading
      >
        <span data-test-location-list-title>
          {{
            (queryString$ | async)?.length > 0
              ? ((locationType === 'origin' ? 'bookingSearch.from.header' : 'bookingSearch.to.headerNoFrom')
                | finLocalization)
              : ((locationType === 'origin' ? 'bookingSearch.from.nearestAiport' : 'trendingDestinations')
                | finLocalization)
          }}
        </span>

        <span *ngIf="(queryString$ | async)?.length > 0" class="is-vishidden" data-test-location-list-results-found>
          &nbsp;{{
            'bookingSearch.a11y.found.' + (locationType === 'origin' ? 'locations' : 'destinations')
              | finLocalization: [(locationResults$ | async)?.length]
          }}</span
        >
      </h3>
    </div>

    <ng-container *ngIf="(isLoading$ | async) === false">
      <ul
        class="flex flex--column"
        tabindex="-1"
        role="listbox"
        [attr.id]="'to-location-' + locationType"
        [attr.aria-labelledby]="locationType + '-list-title'"
        [attr.aria-active-descendant]="'to-location-' + locationType + '-' + (this.activeIndex$ | async)"
      >
        <li
          *ngFor="
            let location of (queryString$ | async)?.length > 0
              ? (locationResults$ | async)
              : (defaultLocations$ | async) as locations;
            let i = index;
            let first = first;
            let last = last
          "
          class="flex flex--middle flex--space-between focus-inset link-hover pr-large-x"
          [class.border-bottom]="!last"
          [class.nordic-blue-50-bg]="i === (this.activeIndex$ | async)"
          [class.nordic-blue-50-border]="i === (this.activeIndex$ | async)"
          [attr.id]="'to-location-' + locationType + '-' + i"
          role="none presentation"
        >
          <button
            class="flex flex--column fill ps-medium-y"
            [tabindex]="
              ((this.activeIndex$ | async) === undefined && first) || (this.activeIndex$ | async) === i ? 0 : -1
            "
            [attr.aria-selected]="i === (this.activeIndex$ | async)"
            role="option"
            (click)="locationSelected.emit({ location, locationType })"
            (keydown)="handleKeyDown($event, locations)"
            #locationItem
            data-test-location-item
          >
            <div class="font-body-1 capitalize location-title">
              <ng-container *ngTemplateOutlet="locationInfo; context: { location: location }"></ng-container>
            </div>
            <div class="font-body-2 ps-xxsmall-y nordic-blue-900-text">
              <i class="flag--small flag-{{ location.countryCode }}"></i>&nbsp;{{ location.title }}
            </div>
          </button>
        </li>
      </ul>
    </ng-container>

    <div class="pr-large-x pr-medium y" role="status" aria-live="assertive" [tabIndex]="-1">
      <p
        *ngIf="
          (queryString$ | async)?.length > 0 &&
          (isLoading$ | async) === false &&
          (locationResults$ | async)?.length === 0
        "
      >
        {{ 'bookingSearch.a11y.found.notFound' | finLocalization: [queryString$ | async] }}
      </p>
    </div>

    <fcom-loader *ngIf="isLoading$ | async" class="pr-large" [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>
</fcom-modal>

<ng-template #locationInfo let-location="location">
  <div *ngIf="location" class="flex fill" data-test-location-info>
    <span class="overflow-hidden truncate">
      {{ location.cityName }}
    </span>
    <span>
      &nbsp;({{
        location.locationCode && location.type === 'airport'
          ? location.locationCode
          : ('bookingSearch.allAirportsLabel' | finLocalization)
      }})</span
    >
    <span class="is-vishidden">&nbsp;{{ location.country }}.</span>
  </div>
</ng-template>
